

let lang = {

  // Netalo config
  'Account': 'Tài khoản',
  'Edit': 'Chỉnh sửa',
  'General settings': 'Cài đặt chung',
  'Notification settings': 'Cài đặt thông báo',
  'Theme settings': 'Cài đặt chủ đề',
  'Theme': 'Chủ đề',
  'Language': 'Ngôn ngữ',
  'Frequently asked questions': 'Câu hỏi thường gặp',
  'Terms of use': 'Điều khoản sử dụng',
  'Support': 'Hỗ trợ',
  'Logout': 'Đăng xuất',
  'Allows notifications': 'Cho phép thông báo',
  'Default': 'Mặc định',
  'Night': 'Ban đêm',
  'Color': 'Màu sắc',
  'Automatically changed by system': 'Tự động thay đổi theo hệ thống',
  'Language settings': 'Cài đặt ngôn ngữ',
  'Profile': 'Hồ sơ cá nhân',
  'Registered phone number cannot be changed': 'Số điện thoại đăng ký không thể thay đổi',
  'Notifications blocked. Please enable them in your browser.': 'Thông báo đã bị chặn. Vui lòng kích hoạt chúng trong trình duyệt của bạn.',
  //Netalo config Frequently asked questions NetAlo
  'How to log in or out on NetAlo?': 'Đăng xuất/nhập trong NetAlo như thế nào?',
  'After opening NetAlo app, log in by filling in your phone number, then tap on the “Continue” button. Then, a message containing your OTP will be sent to your phone. If you don’t receive the message, tap on “Re-send OTP” on the left. If your OTP is successfully verified, you can now start using NetAlo by tapping on the “Start chatting” button. If you wish to log out, tap on the “Account”  button on the bottom-right corner of your phone screen. When your account detail tab is shown, scroll down to the bottom of your phone screen and tap on “Log out”.': 'Sau khi mở app NetAlo, để đăng nhập, bạn hãy nhập số điện thoại của mình, sau đó bấm chọn “Tiếp tục”. Một tin nhắn chứa mã OTP sẽ được gửi đến số điện thoại của bạn. Trong trường hợp không nhận được tin nhắn này, bạn hãy bấm chọn “Gửi lại” phía bên trái màn hình. Sau khi nhận được và xác thực thành công mã OTP, bạn có thể bắt đầu sử dụng NetAlo bằng cách bấm chọn “Bắt đầu chat”. Nếu muốn đăng xuất, bạn hãy bấm nút “Tài khoản”  ở góc phải phía dưới màn hình điện thoại. Lúc này, khung thông tin chi tiết tài khoản của bạn sẽ xuất hiện, bạn hãy vuốt xuống dưới đáy màn hình và bấm chọn “Đăng xuất”.',
  'NetAlo verifies your phone number via OTP code. After you fill in your phone number, a message containing your OTP will be sent to your phone. If you don’t receive the message, tap on “Re-send OTP” on the left. If your OTP is successfully verified, you can now start using NetAlo by tapping on “Start chatting”.': 'NetAlo xác thực số điện thoại của bạn thông qua mã OTP. Sau khi nhập số điện thoại, một tin nhắn chứa mã OTP sẽ được gửi đến số điện thoại của bạn. Trong trường hợp không nhận được tin nhắn này, bạn hãy bấm chọn “Gửi lại” phía bên trái màn hình. Sau khi nhận được và xác thực thành công mã OTP, bạn có thể bắt đầu sử dụng NetAlo bằng cách bấm chọn “Bắt đầu chat”.',
  'On the main page, tap on the “Message” button  on the top-right corner of your phone screen. When a new tab appears, tap on “Create a group chat” (in blue color). NetAlo will then show your contact list. From there, pick those you wish to create a group chat with, then tap on “Done”. You can also create a group chat by choosing a particular chat of yours with another person on the main page. When your message tab shows up, tap on the Name of the person located on top of your phone screen. Another tab showing your contact’s detailed information will appear. Then, tap on “Create group” , choose from your contact list who you wish to invite to the chat group, then tap on “Done”.': 'Tại trang chính, bấm vào nút “Tin nhắn” tại góc phải trên cùng của màn hình điện thoại. Sau khi tab mới xuất hiện, bấm chọn “Tạo nhóm trò chuyện”. Lúc này, danh bạ của bạn sẽ xuất hiện. Bạn hãy chọn những người mà bạn muốn mời tham gia nhóm chat, sau đó bấm chọn “Xong”. Bạn cũng có thể tạo nhóm chat bằng cách bấm chọn một tin nhắn giữa bạn và một người bất kỳ tại trang chính. Khi khung chat xuất hiện, hãy bấm chọn Tên của người đó. Trên tab thông tin chi tiết của người đó, hãy bấm “Tạo nhóm” . Sau đó, chọn từ danh bạ của bạn người bạn muốn mời tham gia nhóm chat, sau đó bấm chọn “Xong”.',
  'NetAlo does not currently support this feature/function.': 'NetAlo hiện không hỗ trợ tính năng này.',
  'How to create a phone call on NetAlo?': 'Cách khởi tạo một cuộc gọi trên NetAlo như thế nào?',
  'Are NetAlo Calls free of charge?': 'Các cuộc gọi từ NetAlo có miễn phí không?',
  'Yes. NetAlo Calls are based on Internet or wi-fi connection. You don’t need to buy phone cards to use it.': 'Các cuộc gọi thông qua NetAlo là hoàn toàn miễn phí. Điện thoại của bạn chỉ cần có kết nối Internet hoặc wi-fi là có thể sử dụng được chức năng này.',
  'Does NetAlo support conference calling?': 'NetAlo có hỗ trợ chức năng gọi điện theo nhóm không?',
  'NetAlo does not currently support this feature/function': 'Hiện tại NetAlo chưa hỗ trợ tính năng này.',
  'How to share photos on NetAlo?': 'Chia sẻ hình ảnh trên NetAlo như thế nào?',
  'On your message page, tap on the “Media” button  located at the bottom-left corner of your phone screen. Then pick the images that you wish to send, then tap “Send”. NetAlo does not limit the number of images or videos that you wish to share.': 'Trong khung tin nhắn giữa bạn với một người bất kỳ, hãy bấm vào nút “Hình ảnh” ở góc trái phía dưới màn hình điện thoại. Sau đó, chọn bất kỳ hình ảnh hoặc video nào bạn muốn gửi đi, và bấm nút “Gửi”. NetAlo không giới hạn số lượng hình ảnh và video mà bạn muốn gửi đi.',
  'How to send a message on NetAlo?': 'Gửi tin nhắn trên NetAlo như thế nào?',
  'This function/feature is currently being developed by NetAlo': 'Chức năng này hiện vẫn đang được đội ngũ NetAlo phát triển.',

  //Netalo config Frequently asked questions GAlo
  'Have Questions? Look Here': 'Những câu hỏi thường gặp',
  'How to log in or out on GAlo?': 'Đăng xuất/nhập trong GAlo như thế nào?',
  'After opening GAlo app, log in by filling in your phone number, then tap on the “Continue” button. Then, a message containing your OTP will be sent to your phone. If you don’t receive the message, tap on “Re-send OTP” on the left. If your OTP is successfully verified, you can now start using GAlo by tapping on the “Start chatting” button. If you wish to log out, tap on the “Account”  button on the bottom-right corner of your phone screen. When your account detail tab is shown, scroll down to the bottom of your phone screen and tap on “Log out”.': 'Sau khi mở app GAlo, để đăng nhập, bạn hãy nhập số điện thoại của mình, sau đó bấm chọn “Tiếp tục”. Một tin nhắn chứa mã OTP sẽ được gửi đến số điện thoại của bạn. Trong trường hợp không nhận được tin nhắn này, bạn hãy bấm chọn “Gửi lại” phía bên trái màn hình. Sau khi nhận được và xác thực thành công mã OTP, bạn có thể bắt đầu sử dụng GAlo bằng cách bấm chọn “Bắt đầu chat”. Nếu muốn đăng xuất, bạn hãy bấm nút “Tài khoản”  ở góc phải phía dưới màn hình điện thoại. Lúc này, khung thông tin chi tiết tài khoản của bạn sẽ xuất hiện, bạn hãy vuốt xuống dưới đáy màn hình và bấm chọn “Đăng xuất”.',
  'How to verify your phone number?': 'Xác thực số điện thoại của bạn như thế nào?',
  'GAlo verifies your phone number via OTP code. After you fill in your phone number, a message containing your OTP will be sent to your phone. If you don’t receive the message, tap on “Re-send OTP” on the left. If your OTP is successfully verified, you can now start using GAlo by tapping on “Start chatting”.': 'GAlo xác thực số điện thoại của bạn thông qua mã OTP. Sau khi nhập số điện thoại, một tin nhắn chứa mã OTP sẽ được gửi đến số điện thoại của bạn. Trong trường hợp không nhận được tin nhắn này, bạn hãy bấm chọn “Gửi lại” phía bên trái màn hình. Sau khi nhận được và xác thực thành công mã OTP, bạn có thể bắt đầu sử dụng GAlo bằng cách bấm chọn “Bắt đầu chat”.',
  'How to create a group chat?': 'Làm sao để tạo một nhóm chat?',
  'On the main page, tap on the “Message” button  on the top-right corner of your phone screen. When a new tab appears, tap on “Create a group chat” (in blue color). GAlo will then show your contact list. From there, pick those you wish to create a group chat with, then tap on “Done”. You can also create a group chat by choosing a particular chat of yours with another person on the main page. When your message tab shows up, tap on the Name of the person located on top of your phone screen. Another tab showing your contact’s detailed information will appear. Then, tap on “Create group” , choose from your contact list who you wish to invite to the chat group, then tap on “Done”.': 'Tại trang chính, bấm vào nút “Tin nhắn” tại góc phải trên cùng của màn hình điện thoại. Sau khi tab mới xuất hiện, bấm chọn “Tạo nhóm trò chuyện”. Lúc này, danh bạ của bạn sẽ xuất hiện. Bạn hãy chọn những người mà bạn muốn mời tham gia nhóm chat, sau đó bấm chọn “Xong”. Bạn cũng có thể tạo nhóm chat bằng cách bấm chọn một tin nhắn giữa bạn và một người bất kỳ tại trang chính. Khi khung chat xuất hiện, hãy bấm chọn Tên của người đó. Trên tab thông tin chi tiết của người đó, hãy bấm “Tạo nhóm” . Sau đó, chọn từ danh bạ của bạn người bạn muốn mời tham gia nhóm chat, sau đó bấm chọn “Xong”.',
  'How to add someone into a group chat?': 'Làm sao để thêm một thành viên khỏi danh sách nhóm chat?',
  'On the main page, choose one particular group chat that you wish to add new contacts to. When the message tab appears, tap on the Name of the group chat located on top of your phone screen. When another tab showing your group chat details appears, tap on “Add contact” . From your contact list, pick those you wish to invite to your group chat, then tap on “Done”.': 'Tại trang chính, chọn một nhóm chat bất kỳ. Khi khung tin nhắn của nhóm chat này hiển thị, hãy bấm vào phần Tên của nhóm chat ở phía trên cùng màn hình điện thoại. Lúc này, một tab hiển thị thông tin chi tiết của nhóm chat sẽ xuất hiện. Bạn hãy bấm chọn “Thêm thành viên” . Sau khi danh bạ của bạn hiện ra, hãy chọn những người bạn muốn mời tham gia nhóm chat, sau đó bấm chọn “Xong”.',
  'How to remove someone from a group chat?': 'Làm sao để xóa một thành viên ra khỏi danh sách nhóm chat?',
  'GAlo does not currently support this feature/function.': 'GAlo hiện không hỗ trợ tính năng này.',
  'How to leave a group chat?': 'Rời khỏi một nhóm chat như thế nào?',
  'On the main page, choose one particular group chat that you wish to leave. When the message tab appears, tap on the Name of the group chat located on top of your phone screen. When another tab showing your group chat details appears, tap on “Leave group” (in red color) to leave the group chat.': 'Tại trang chính, chọn một nhóm chat bất kỳ. Khi khung tin nhắn của nhóm chat này hiển thị, hãy bấm vào phần Tên của nhóm chat ở phía trên cùng màn hình điện thoại. Lúc này, một tab hiển thị thông tin chi tiết của nhóm chat sẽ xuất hiện. Bạn hãy bấm chọn “Rời nhóm” để rời khỏi nhóm chat.’+',
  'How to see a group chat’s participation list?': 'Làm sao để xem danh sách thành viên trong một nhóm chat?',
  'On the main page, choose one particular group chat that you wish to view the participation list of. When the message tab appears, tap on the Name of the group chat located on top of your phone screen. When another tab showing your group chat details appears, scroll down to the bottom to see the participation list.': 'Tại trang chính, chọn một nhóm chat bất kỳ. Khi khung tin nhắn của nhóm chat này hiển thị, hãy bấm vào phần Tên của nhóm chat ở phía trên cùng màn hình điện thoại. Lúc này, một tab hiển thị thông tin chi tiết của nhóm chat sẽ xuất hiện. Bạn hãy kéo xuống phía dưới cùng của màn hình để xem danh sách thành viên nhóm chat.',
  'How to create a phone call on GAlo?': 'Cách khởi tạo một cuộc gọi trên GAlo như thế nào?',
  'On the main page, tap on the “Phone call”  button (second position from the left, located at the bottom of your phone screen). When a new tab appears, tap on “Start new phone call”. This will take you to your “Contacts” page. Choose a particular contact that you want to call. Then, when your message tab with that contact appears, tap on the “Phone call” button located at the top-right corner of your phone screen.': 'Tại trang chính, bấm vào nút “Cuộc gọi” (nút thứ 2 từ trái qua, nằm phía dưới màn hình điện thoại). Khi tab mới xuất hiện, bấm chọn “Bắt đầu cuộc gọi mới”. Lúc này bạn sẽ được đưa tới trang “Danh bạ”. Sau khi chọn người để gọi, một tab tin nhắn giữa bạn và người đó sẽ xuất hiện. Lúc này, bạn bấm vào nút “Gọi điện” ở phía trên bên phải màn hình điện thoại để thực hiện cuộc gọi.',
  'Are GAlo Calls free of charge?': 'Các cuộc gọi từ GAlo có miễn phí không?',
  'Yes. GAlo Calls are based on Internet or wi-fi connection. You don’t need to buy phone cards to use it.': 'Các cuộc gọi thông qua GAlo là hoàn toàn miễn phí. Điện thoại của bạn chỉ cần có kết nối Internet hoặc wi-fi là có thể sử dụng được chức năng này.',
  'Does GAlo support conference calling?': 'GAlo có hỗ trợ chức năng gọi điện theo nhóm không?',
  'GAlo does not currently support this feature/function': 'Hiện tại GAlo chưa hỗ trợ tính năng này.',
  'How to share photos on GAlo?': 'Chia sẻ hình ảnh trên GAlo như thế nào?',
  'On your message page, tap on the “Media” button  located at the bottom-left corner of your phone screen. Then pick the images that you wish to send, then tap “Send”. GAlo does not limit the number of images or videos that you wish to share.': 'Trong khung tin nhắn giữa bạn với một người bất kỳ, hãy bấm vào nút “Hình ảnh” ở góc trái phía dưới màn hình điện thoại. Sau đó, chọn bất kỳ hình ảnh hoặc video nào bạn muốn gửi đi, và bấm nút “Gửi”. GAlo không giới hạn số lượng hình ảnh và video mà bạn muốn gửi đi.',
  'How do I edit my profile?': 'Làm thế nào để chỉnh sửa thông tin tài khoản?',
  'On the main page, tap on the “Account” button  located at the bottom-right corner of your phone screen. Then, a new tab showing your account’s detailed information will appear for you to edit.': 'Tại trang chính, bấm vào nút “Tài khoản” ở góc phải phía dưới màn hình điện thoại của bạn. Lúc này, trang thông tin chi tiết của tài khoản của bạn sẽ xuất hiện để bạn có thể tùy ý chỉnh sửa.',
  'How to manage your notification?': 'Tùy chỉnh thông báo như thế nào?',
  'If you want to silence a message’s notification, tap on one of the messages shown on the main page. Then, when your chosen message is opened, tap on the Name of the contact located on top of the message tab. When another tab showing your contact’s details appeared, tap on the “Stop notification”  button located at the bottom of your phone screen.': 'Nếu bạn muốn tắt thông báo của một tin nhắn bất kỳ, hãy bấm chọn tin nhắn đó tại trang chính. Sau khi khung tin nhắn hiện ra, hãy bấm vào Tên người bạn đang nhắn tin cùng. Lúc này, một tab hiển thị thông tin chi tiết của người đó sẽ xuất hiện. Bạn hãy bấm nút “Tắt thông báo” ở phía dưới màn hình điện thoại.',
  'How to send a message on GAlo?': 'Gửi tin nhắn trên GAlo như thế nào?',
  'On the main page, tap on the “Message” button  on the top-right corner of your phone screen. The “Contacts” page  will then be opened. From there, choose one particular contact of yours and start sending messages. Another way is going directly to “Contacts” page  (third button from the left, located at the bottom of your screen), then choose one particular contact on your list and start sending messages.': 'Tại trang chính, bấm vào nút “Tin nhắn” tại góc phải trên cùng trên màn hình điện thoại. Trang “Danh bạ” của bạn sau đó sẽ xuất hiện. Lúc này, chọn một đối tượng từ trong danh sách danh bạ và bắt đầu gửi tin nhắn. Ngoài ra bạn có thể trực tiếp bấm vào nút “Danh bạ” (nút thứ 3 từ trái qua, nằm ở phía dưới màn hình điện thoại), sau đó chọn một đối tượng và bắt đầu gửi tin nhắn.',
  'Can I listen to my own voice chat before sending it?': 'Tôi có thể thử nghe tin nhắn giọng nói của mình trước khi gửi đi không?',
  'This function/feature is currently being developed by GAlo': 'Chức năng này hiện vẫn đang được đội ngũ GAlo phát triển.',
  'How to send a voice chat?': 'Gửi một tin nhắn giọng nói như thế nào?',
  'On the main page, choose one particular message of yours. A new tab showing your message with that one particular contact of yours will appear. Then tap on the “Microphone” button  located at the bottom-left corner of your phone screen and start recording your voice. After you finished, tap on “Stop recording”, then tap “Send” if you agree to send the voice message.': 'Tại trang chính, chọn một tin nhắn bất kỳ của bạn. Lúc này, tab tin nhắn giữa bạn và người đã chat với bạn sẽ xuất hiện. Hãy bấm vào nút “Ghi âm” nằm ở góc trái phía dưới màn hình điện thoại của bạn và bắt đầu ghi âm. Sau khi ghi âm xong, bấm nút “Dừng ghi âm”, sau đó bấm “Gửi” nếu bạn quyết định gửi đi tin nhắn thoại này.',

  //Netalo config Terms of use NetAlo
  'Terms Of Service': 'Điều Khoản Sử Dụng BOBACU',

  //Netalo config Terms of use GAlo
  'GAlo Terms Of Service': 'THỎA THUẬN CUNG CẤP VÀ SỬ DỤNG DỊCH VỤ MẠNG XÃ HỘI GAlo',
  // Netalo chat
  'New Group Chat': 'Nhóm trò chuyện mới',
  'New Channel': 'Kênh trò chuyện mới',

  'Chat': 'Cuộc trò chuyện',
  'Chats': 'Các cuộc trò chuyện',
  'Create a group': 'Tạo nhóm',
  'Create a channel': 'Tạo kênh',
  'Enter a group name': 'Nhập tên nhóm',
  'Search': 'Tìm kiếm',
  'Recent contact': 'Liên hệ gần đây',
  'Recent search': 'Tìm kiếm gần đây',
  'You have not had any chat yet': 'Bạn chưa có trò chuyện nào',
  'Start now': 'Bắt đầu ngay',
  'Write a message': 'Viết tin nhắn',
  'Choose a chat to start': 'Chọn một cuộc trò chuyện để bắt đầu',
  'Share': 'Chia sẻ',
  'You have not selected a member': 'Bạn chưa chọn thành viên',
  'Add contact': 'Thêm liên hệ',
  'Please create a chat first': 'Bạn vui lòng tạo cuộc trò chuyện trước',
  //netalochat index.js- groups
  ' created a group': ' đã tạo nhóm',
  ' created a channel': ' đã tạo kênh trò chuyện',
  'Start chat with ': 'Bắt đầu chat với ',
  'Unread Messages': 'Tin nhắn chưa đọc',
  ' finished': ' đã kết thúc',
  'The group name can not be blank': 'Tên nhóm không được để trống',
  'The message has been deleted': 'Tin nhắn đã bị xoá',
  ' unsent a message': ' đã xóa tin nhắn',
  'Voice call': 'Gọi thoại',
  'Video call': 'Gọi Video',
  'Image': 'Hình ảnh',
  ' added ': ' đã thêm ',
  ' removed ': ' đã xóa ',
  ' has left the group': ' đã rời khỏi nhóm',
  'File': 'Tập tin',
  'Canceled': 'Đã huỷ',
  'Missed': 'Bị nhỡ',
  'Missed Call': 'Cuộc gọi bị nhỡ',
  'Canceled Call': 'Cuộc gọi bị huỷ',
  'Call Ended': 'Cuộc gọi kết thúc',
  'Answer for': 'Trả lời cho',
  'forwarded a message': 'đã chuyển tiếp một tin nhắn',
  'You': 'Bạn',
  'New message': 'Tin nhắn mới',
  'New Message': 'Tin nhắn mới',
  'The group must have at least three members': 'Nhóm phải có ít nhất từ ba thành viên trở lên',
  //netalochat index.jsx- groups
  'View profile': 'Thông tin người dùng',
  'Manage group': 'Quản lý nhóm',
  'Mark as unread': 'Đánh dấu chưa đọc',
  'Hide conversation': 'Ẩn cuộc hội thoại',
  'Delete conversation': 'Xóa cuộc hội thoại',
  'Delete conversation Draft': 'Xóa hội thoại nháp',
  'Delete Call History': 'Xóa cuộc gọi',
  'Leave group': 'Rời khỏi nhóm',
  'Unfollow': 'Bỏ theo dõi',
  'Create a group chat': 'Tạo nhóm trò chuyện',
  //netalochat index.js- message
  'Reply': 'Trả lời',
  'Forward': 'Chuyển tiếp',
  'Copy': 'Sao chép',
  'Cut': 'Cắt',
  'Paste': 'Dán',
  'Pin': "Ghim",
  "Pinned Message": "Tin nhắn đã ghim",
  'Unpin All': 'Bỏ ghim tất cả',
  'Share Group\'s Link': "Chia sẽ liên kết nhóm",
  'Revoke Link': "Thu hồi liên kết",
  'Join Group Failed': "Tham gia nhóm không thành công",
  ' pinned': " đã ghim tin nhắn",
  ' pinned one message': " đã ghim một tin nhắn",
  ' update avatar': " đã cập nhật hình đại diện",
  ' update group name': " đã cập nhật tên cuộc trò chuyện",
  ' update group info': " đã cập nhật thông tin ",
  ' change group admin to: ': " đã chuyển trưởng nhóm thành: ",
  ' add new admin ': " đã thêm trưởng nhóm mới ",
  ' joined group with link': " đã tham gia nhóm bằng liên kết",
  ' remove: ': " đã xoá thành viên: ",
  'Group is unpin all message': "Nhóm đã bỏ ghim tin nhắn",
  "Unpin all message": "Bỏ ghim tất cả tin nhắn",
  ' unpin all message': ' đã bỏ ghim tất cả tin nhắn',
  "Unpin": "Bỏ ghim",
  " unpin: ": " đã bỏ ghim: ",
  " unpin one message": " đã bỏ ghim một tin nhắn",
  'Delete with everyone': 'Xóa với tất cả mọi người',
  'Delete only me': 'Xóa chỉ mình tôi',
  // Netalo contact
  'Find contacts': 'Tìm danh bạ',
  'Account information': 'Thông tin tài khoản',
  'Offline': 'Đang ngoại tuyến',
  'Find messages': 'Tìm tin nhắn',
  'Share contacts': 'Chia sẻ danh bạ',
  'View more': 'Xem thêm',
  'Select a chat to start': 'Chọn một cuộc trò chuyện để bắt đầu',
  'Delete Contact': 'Xóa danh bạ',
  'Edit Name Contact': 'Sửa tên danh bạ',
  'The user does not exist on the system': 'Người dùng không tồn tại trên hệ thống',
  'Offline': 'Ngoại tuyến',
  'Online': 'Trực tuyến',
  // Netalo callhistory
  'Search Calls': 'Tìm kiếm cuộc gọi',
  'Call away': 'Cuộc gọi đi',
  'Incoming call': 'Cuộc gọi đến',
  'Missed call': 'Cuộc gọi nhỡ',

  // Netalo callhistory call
  'Contacting...': 'Đang liên hệ...',
  'Ringing': 'Đang đổ chuông',
  'Is Calling': 'đang gọi bạn',
  // Netalo call
  'CALLING...': 'ĐANG GỌI ...',

  'Check input/output device sound please': 'Vui lòng kiểm tra thiết bị đầu ra và đầu vào âm thanh',

  //classes ulti.js
  'Sunday': 'Chủ Nhật',
  'Monday': 'Thứ Hai',
  'Tuesday': 'Thứ Ba',
  'Wednesday': 'Thứ Tư',
  'Thursday': 'Thứ Năm',
  'Friday': 'Thứ Sáu',
  'Saturday': 'Thứ Bảy',
  // rxAccountInfo
  'Last seen ': 'Xem lần cuối ',
  ' member': ' thành viên',
  'Phone number': 'Số điện thoại',
  'Customer Id': 'Mã khách hàng',
  'Block contact': 'Chặn liên hệ',
  'Unblock contact': 'Bỏ chặn liên hệ',
  'Accept': 'Đồng ý',
  'Block list': 'Danh sách liên hệ đã chặn',
  'Status Profile': 'Trạng thái',
  'You haven\'t blocked any contact': 'Bạn chưa chặn một liên hệ nào',
  'Are you sure you want to block this contact, you and this person will not be able to make calls or send messages':
    'Bạn có muốn chặn người này, bạn và người này sẽ không thể gọi điện hay gửi tin nhắn cho nhau',
  'Are you sure you want to unblock this contact': 'Bạn có muốn bỏ chặn người này',
  'This person has been blocked, cannot make calls or send messages': 'Người này đã bị chặn, không thể gọi điện hoặc nhắn tin',
  'Currently, you cannot make contact to this person': 'Hiện tại bạn không thể liên lạc với người này',
  'Pin group': 'Ghim nhóm',
  'Document': 'Tài liệu',
  'Owner': 'Trưởng nhóm',
  'Admin': 'Quản trị viên',
  'Group name': 'Tên nhóm',
  'Description': 'Mô tả kênh',
  'Describe with 150 characters': 'Mô tả với 150 ký tự',
  'Add new leader': 'Thêm trưởng nhóm mới',
  'Choose owner': 'Chọn trưởng nhóm',
  'Are you sure you want to leave the group? After leaving the group, you will not be able to read this group news': 'Bạn có chắc là muốn rời khỏi nhóm không? Sau khi rời nhóm, bạn sẽ không đọc được tin của nhóm này',
  'Are you sure you want to delete this conversation?': 'Bạn có chắc là muốn xoá cuộc hội thoại này không?',
  'Cancel': 'Hủy',
  'Edit name': 'Sửa tên',
  'Group members': 'Thành viên nhóm',
  'Add member': 'Thêm thành viên',
  'Add participants': 'Thêm người tham gia',
  'Add Member Error': 'Thêm Thành Viên Không Thành Công',
  'Link Sharing Group': 'Chia sẻ liên kết nhóm',
  'Group QR code': 'Mã QR nhóm',
  'Copy Link Group': 'Sao chép liên kết',
  'Copied': 'Đã sao chép',
  'Remove': 'Xóa',
  'Download QR': 'Tải xuống QR',
  'CONTACT': 'LIÊN HỆ',
  'GROUP': 'NHÓM',
  'Notification sound': 'Âm thanh thông báo',
  'Current Location': 'Vị trí hiện tại',
  'Live Location': 'Hành trình trực tiếp',
  'Group name contains invalid characters': 'Tên nhóm có chứa ký tự không hợp lệ',
  //rxUploadFile
  'Photos and Videos': 'Hình ảnh và Video',
  'Documents and Files': 'Tài liệu và Tập tin',
  'Add attachment(s)': 'Tệp đính kèm',
  'Drop files here': 'Thả tệp ở đây',
  ' file is selected': ' tệp đã được chọn',
  //rxAudioRecord
  'The file format is not suitable. Please select the file as .wav': 'Định dạng file không phù hợp.Vui lòng chọn file là .wav',
  'The file format is not suitable. Please select the file as xlsx, xls, doc, docx, ppt, pptx, txt, pdf, numbers, key, pages, zip, jpg, gif, bmp, png, m4v, avi, mpg, mp4': 'Định dạng file không phù hợp.Vui lòng chọn file là xlsx, xls, doc, docx, ppt, pptx, txt, pdf, numbers, key, pages, zip, jpg, gif, bmp, png, m4v, avi, mpg, mp4',
  'The recording upto 1 minute': 'Đoạn ghi âm tối đa 1 phút',
  'Stop recording': 'Dừng thu âm',
  'Send': 'Gửi',

  'group': 'nhóm',
  'chat': 'cuộc trò chuyện',
  'channel': 'kênh',
  'Connecting': 'Đang kết nối',

  //rxCrud
  'You want to delete this data!': 'Bạn muốn xoá dữ liệu này !',
  'Name': 'Tên',
  'Created at': 'Được tạo lúc',
  'Action': 'Hoạt động',
  'Off': 'Tắt',
  'Total Rows': 'Tổng số hàng',
  'Add': 'Thêm',
  'Advance Filter': 'Bộ lọc nâng cao',
  'Generate permissions': 'Tạo quyền',
  'Find by ': 'Tìm theo ',

  //rxGroupList
  'Stranger': 'Người lạ',

  //rxNewUserInfo
  'last seen today at ': 'đã xem lần cuối vào hôm nay lúc ',
  'Start the conversation secret': 'Bắt đầu cuộc trò chuyện bí mật',
  'Turn off notifications': 'Tắt thông báo',
  'Turn on notifications': 'Bật thông báo',
  'Chat Folder': 'Phân loại trò chuyện',
  //rxModalEdit
  'Add a contact': 'Thêm liên hệ',
  'User name': 'Tên tài khoản đăng nhập',
  'Full name': 'Tên liên hệ',
  'Name is too short': 'Tên quá ngắn',
  'Phone is invalid': 'Số điện thoại ko hợp lệ',
  'Enter your full name': 'Nhập tên liên hệ',
  'Enter your user name': 'Nhập tên tài khoản',
  'Done': 'Xong',

  //rxModalMouseRightChat
  'Mark as read': 'Đánh dấu đã đọc',
  'Mark as read all': 'Đánh dấu đã đọc hết',
  'Unpin a conversation': 'Bỏ ghim cuộc trò chuyện',
  'Pin a conversation': 'Ghim cuộc trò chuyện',
  'Hide a conversation': 'Ẩn cuộc trò chuyện',
  'Delete Conversation': 'Xóa cuộc hội thoại',
  'Delete': 'Xóa',
  'Click to select': 'Nhấp vào để chọn',

  //rxTemplates
  'Review': 'Đánh giá',
  'Manage reviews': 'Quản lý bài đánh giá',

  //rxUploadFile
  'Formats not supported': 'Định dạng không hổ trợ',
  'Formats not supported: ': 'Định dạng không hổ trợ: ',
  'The file format is not suitable. Please select the file as .xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .pdf': 'Định dạng file không phù hợp.Vui lòng chọn file là .xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .pdf',
  'The image file format is not suitable': 'Định dạng file hình không phù hợp',
  'The image file format is not suitable. Please select the image file as .jpg or .png': 'Định dạng file hình không phù hợp. Vui lòng chọn file hình là .jpg hoặc là .png',
  'The video file format is not suitable. Please select the video file as .mp4': 'Định dạng file video không phù hợp. Vui lòng chọn file video là .mp4',
  'Video size is too large': 'Kích thước video quá lớn',
  'File size is too large': 'Kích thước tập tin quá lớn',
  'Downloading your file please wait ...': 'Tập tin đang tải xuống, vui lòng chờ trong giây lát',

  'is typing': 'đang nhập',

  // InfoProfile
  'Email': 'Email',
  'Phone': 'SĐT',
  'Department': 'Phòng ban',
  'Work Place': 'Địa điểm',
  'Customer Id': 'Mã khách hàng',
  'Your Mission': 'Nhiệm vụ của bạn',

  //GroupCall
  'Group Call': 'Cuộc gọi nhóm',
  'Join': 'Tham gia',
  'Joined': 'Đã tham gia',
  'Ongoing Group Call': 'Cuộc gọi nhóm đang diễn ra',
  'You were on a group call': 'Bạn đã tham gia cuộc gọi nhóm',

  //message pin
  'Images': 'Hình ảnh',
  'Audio record': 'Ghi âm',
  'Video': 'Video',
  'Documents': 'Tài liệu',

  'You are not a member of this group': 'Bạn không phải là thành viên của nhóm này',
  'Group not found': 'Nhóm không tìm thấy',

  ' mention you in a conversation ': ' nhắc tới bạn trong 1 hội thoại ',
  'Share your status': 'Chia sẻ trạng thái hiện tại của bạn',
  'Set a status': 'Đặt trạng thái',
  'Suggestion Status': 'Trạng thái gợi ý',

  'No matches found': 'Không tìm thấy kết quả phù hợp',

  //poll
  'Finished': 'Đã kết thúc',
  'Poll list': 'Danh sách bình chọn',
  'View poll': 'Xem bình chọn',
  'Poll': 'Bình chọn',
  'Vote': 'Bình chọn',
  'List of options': 'Danh sách các phương án',
  ' people voted': ' người đã bình chọn',
  'Optional': 'Tuỳ chọn',
  'Pin to the top of a group chat': 'Ghim lên đầu trò chuyện nhóm',
  'Send to the chat group': 'Gửi vào nhóm chat',
  'End of voting': 'Kết thúc bình chọn',
  'Delete vote': 'Xoá bình chọn',
  'Change vote': 'Đổi bình chọn',
  'Voting has ended': 'Bình chọn đã kết thúc',
  'Group board': 'Bảng tin nhóm',
  'Creation time': 'Thời gian tạo',
  'Vote details': 'Chi tiết bình chọn',
  'Remain ': 'Còn ',
  ' more options': ' phương án khác',
  'Create poll': 'Tạo bình chọn mới',
  'Create Poll': 'Tạo bình chọn mới',
  'Option ': 'Phương án ',
  'Add option': 'Thêm phương án',
  'Ask a question': 'Đặt câu hỏi bình chọn',
  ' participated in a new poll "': ' đã tham gia cuộc bình chọn mới "',
  ' changed vote "': ' đã thay đổi bình chọn "',
  ' just shared the a poll "': ' đã chia sẽ cuộc bình chọn "',
  ' See': ' Xem',
  ' have finished voting "': ' đã kết thúc cuộc bình chọn "',
  'Poll has been deleted': 'Bình chọn đã bị xoá',
  'Please update your name before do this change': 'Vui lòng cập nhật tên của bạn trước khi thực hiện thay đổi này',
  'Ends at ': 'Kết thúc vào lúc ',
  'There was an error when changing group, please logout and login into the app to use this feature': 'có lỗi xảy ra khi thay đổi nhóm, bạn vui lòng đăng xuất và đăng nhập lại ứng dụng để sử dụng tính năng này',
  'Create poll to help the group decide faster.': 'Tạo bình chọn để giúp nhóm quyết định nhanh hơn.',
  'You can only create up to 5 poll': 'Chỉ được tạo tối đa 5 bình chọn',
  'Please tell us your opinion': 'Hãy cho biết ý kiến của bạn',
  ' just unpinned the poll': ' vừa bỏ ghim cuộc bình chọn',
  ' just pinned the poll': ' vừa ghim cuộc bình chọn',

  ' mention you in a conversation ': ' nhắc tới bạn trong 1 hội thoại ',

  'You can only create reminder during the day': 'Bạn chỉ tạo được lịch làm việc trong ngày',
  'Please select an end time greater than start': 'Vui lòng chọn thời gian kết thúc phải lớn hơn bắt đầu',
  'Please select the location first': 'Vui lòng chọn địa điểm trước',

  'Suggested': 'Được gợi ý',
  'English': 'Tiếng Anh',
  'Vietnamese': 'Tiếng Việt',
  'There was an error when changing emoji, please logout and login into the app to use this feature': 'có lỗi xảy ra khi thay đổi emoji, bạn vui lòng đăng xuất và đăng nhập lại ứng dụng để sử dụng tính năng này',
  'Please rate the quality of your call': 'Bạn thấy chất lượng cuộc gọi như thế nào?',
  'Thank for your rating': 'Cảm ơn bạn đã góp ý',
  'Not now': 'Quay lại',
  'Submit': 'Gửi đánh giá',
  'Links': 'Liên kết',
  'Add new admininistrator': "Thêm quản trị viên",
  'List of admininistrators': "Danh sách quản trị viên",
  'to group\'s admins list': "vào danh sách quản trị viên",
  'from group\'s admins list': "khỏi danh sách quản trị viên",
  'Status': 'Trạng thái',
  'View all': 'Xem tất cả',

  // Calendar
  'Calendar': 'Lịch làm việc',
  'Event details': 'Chi tiết lịch hẹn',
  'Created By': 'Tạo bởi',
  'Time': 'Thời gian',
  'From': 'Từ',
  'To': 'Đến',
  'Location': 'Địa điểm',
  'Event Category': 'Nhóm sự kiện',
  'Participants': 'Người tham gia',
  'Note': 'Ghi chú',
  'Reminder': 'Nhắc hẹn',
  'Create new event': 'Thêm lịch mới',
  'Edit event': 'Chỉnh sửa lịch hẹn',
  'Done': 'Xong',
  'Enter title': 'Nhập tiêu đề',
  'Start': 'Bắt đầu',
  'End': 'Kết thúc',
  'Save': 'Lưu',
  'Description': 'Mô tả đầy đủ',
  'Option': 'Tuỳ chọn',
  'Edit event ': 'Sửa lịch hẹn',
  'Delete event': 'Xoá lịch hẹn',
  'Do you want to delete this event': 'Bạn có chắc muốn xoá sự kiện này không',
  'Reminder has not been completed, do you want to finish it?': 'Phiên tạo lịch chưa xong, bạn có muốn kết thúc quá trình này không?',
  'Delete': 'Xoá ngay',
  'Select time': 'Chọn thời gian',
  'You are no longer in this group': 'Bạn không còn trong nhóm này.',
  ' promoted ': ' đã chọn ',
  ' to group owner': ' làm trưởng nhóm mới'
}


// const { rxaget ,changeColorSVG} = global.rootRequire('classes/ulti')

let translate = function (value) {
  if (typeof localStorage !== 'undefined') {
    let language = localStorage.getItem('netaLang')

    if (typeof lang[value] !== 'undefined') {
      if (language === JSON.stringify('en')) {
        return value
      } else if (language === JSON.stringify('vi')) {
        return lang[value]
      }
      return lang[value]
    } else {
      return value
    }
  }
}


export default translate